/* eslint-disable no-await-in-loop */
import { PDFDocument } from 'pdf-lib'
import print from 'print-js'

export async function mergeAndOpenPdfs(pdfs: Uint8Array[]): Promise<void> {
	const merged = await PDFDocument.create()

	for (const pdfBytes of pdfs) {
		const doc = await PDFDocument.load(pdfBytes)
		const pages = await merged.copyPages(doc, doc.getPageIndices())
		pages.forEach(page => merged.addPage(page))
	}

	const bytes = await merged.save()
	const base64 = btoa(String.fromCharCode(...bytes))

	return new Promise((resolve, reject) => {
		print({
			printable: base64,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}
